(function($, window, undefined) {
  if (window.mg === undefined)
    window.mg = {};

  if (window.mg.ui === undefined)
    window.mg.ui = {};

  const _ = window.mg;

  const notEmpty = () => {
    // override default with trim
    return {
      validate(input) {
        const opts  = $.extend({ trim: true }, input.options);
        const value = opts.trim === true || opts.trim === 'true' ? $.trim(input.value) : input.value;

        return {
          valid : value !== ''
        };
      }
    };
  };

  const golfId = () => {
    const regex = /^\d{6}-\d{3}$/;

    return {
      validate(input) {
        return {
          valid   : input.value !== '' && regex.test(input.value),
          message : _.translations.GolfIdValidator
        };
      }
    };
  };

  if (window.hasOwnProperty('FormValidation')) {
    FormValidation.validators.notEmpty = notEmpty;
    FormValidation.validators.golfId   = golfId;
  }

  const hideSuccess = (e) => {
    if (!e.valid)
      return;

    const elemRowSelector = e.elements.find((v) => {
        return 'rowSelector' in v.dataset && v.dataset.rowSelector != '';
    });

    const elemGroup = FormValidation.utils.closest(e.element, elemRowSelector ? elemRowSelector.dataset.rowSelector : '.form-group');

    elemGroup && FormValidation.utils.classSet(elemGroup, { 'has-success': false });

    e.elements.forEach((v) => {
        FormValidation.utils.classSet(v, { 'is-valid': false });
    });
  };

  const camelCase = (value) => {
    return value
      .replace(/\s(.)/g, ($1) => $1.toUpperCase())
      .replace(/\s/g, '')
      .replace(/^(.)/, ($1) => $1.toLowerCase());
  };


  const styleAsInvaild = (inputElement) => {
      const customAttrName = 'data-mg-validation-field-is-invalid-until-change';
      if (inputElement) {
          inputElement.setAttribute(customAttrName, '1');
          const evtHandler = (e) => {
              e.currentTarget.setAttribute(customAttrName, '0');
          }
          $(inputElement).off('focus', evtHandler).on('focus', evtHandler);
      }
  }

  const styleAsInvaild_resetAll = () => {
      const customAttrName = 'data-mg-validation-field-is-invalid-until-change';
      $(`[${customAttrName}]`).attr(customAttrName, '0');
  }

  class Validation {
    constructor(form) {
      this._$form   = $(form);
      this._plugins = {};
      this._events  = [];

      this.addPlugin('Aria');
      this.addPlugin('AutoFocus');
      this.addPlugin('Bootstrap');
      this.addPlugin('Declarative');
      this.addPlugin('SubmitButton');
      this.addPlugin('Excluded');

      this.addEvent('core.element.validated', hideSuccess);

      return this;
    }

    addPlugin(name, options) {
      const pluginName = camelCase(name);
      this._plugins[pluginName] = new FormValidation.plugins[name](options);

      return this;
    }

    removePlugin(name) {
      const pluginName = camelCase(name);
      delete this._plugins[pluginName];

      return this;
    }

    updatePluginOptions(name, options) {
      const pluginName = camelCase(name);

      if ('opts' in this._plugins[pluginName])
        $.extend(true, this._plugins[pluginName].opts, options);

      return this;
    }

    addEvent(name, callback) {
      this._events.push({
        name     : name,
        callback : callback
      });

      return this;
    }

    removeEvent(name) {
      this._events = $.grep(this._events, (v) => v.name != name);

      return this;
    }

    init(options) {
      this.fv = FormValidation.formValidation(this._$form[0], $.extend(true, {
        locale       : _.formValidationLang,
        localization : FormValidation.locales[_.formValidationLang],
        plugins      : this._plugins
      }, options || {}));

      $.each(this._events, (i, v) => {
        this.fv.on(v.name, v.callback);
      });

      this._$form.data('ui.validation', this);

      return this;
    }

    destroy() {
      return Validation.destroy(this._$form);
    }

    static destroy(form) {
      const $form    = $(form);
      const instance = $form.data('ui.validation');

      instance.fv.destroy();
      instance._$form.removeData('ui.validation');

      return instance;
    }
  }

  _.ui.validation         = (form) => new Validation(form);
  _.ui.validation.destroy = (form) => Validation.destroy(form);
  _.ui.validation.get     = (form) => $(form).data('ui.validation');
  _.ui.validation.styleAsInvalid =  styleAsInvaild;
  _.ui.validation.styleAsInvalid_resetAll =  styleAsInvaild_resetAll;
})(jQuery, window);
